import { render, staticRenderFns } from "./CorporateAccounts.vue?vue&type=template&id=1512c7dd"
import script from "./CorporateAccounts.vue?vue&type=script&lang=js"
export * from "./CorporateAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports